import { errorStore } from "@/modules/errors/store/errors";
import RobotSessionView from "../views/RobotSessionView.vue";
import RobotView from "../views/RobotsView.vue";

export default {
  path: "/robots",
  name: "RobotPage",
  children: [
    {
      path: ":robotImei",
      name: "RobotSession",
      params: true,
      props: {
        // You must set `true` to the default view, which uses SessionDetail
        default: true,
      },
      component: RobotSessionView,
      meta: { 
        requiresAuth: true,
        roles: ["ADMIN", "INSTALLER"],
      },
      beforeEnter: (to, from, next) => {
       
        const query = { ...to.query, ...from.query }
        console.log(query)
        if(!query.from){
          query['from']= from.fullPath
        }
        if(!query.basestation){
          query['basestation']=from.params['basestation']?from.params.basestation:""
        }
        if (!Object.keys(to.query).length && !Object.keys(from.query).length) {
          return next({ ...to, query })
        } else {
          return next()
        }

        
      },
    },
    {
      path: "",
      name: "Robot",
      component: RobotView,
      meta: {
        requiresAuth: true,
        roles: ["ADMIN", "INSTALLER"],
      },
      beforeEnter: (to, from, next) => {
        return next();
      },
    },
  ],
  meta: {
    requiresAuth: true,
    roles: ["ADMIN", "INSTALLER"],
  },
  beforeEnter: (to, from, next) => {
    errorStore.clean();
    return next();
  },
};
